import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
//import Layout from './layouts/Layout';
import MyLayout from "./mlscan/MyLayout";


import 'react-toastify/dist/ReactToastify.min.css';
import 'react-datetime/css/react-datetime.css';
import 'react-image-lightbox/style.css';
import './mystyles.css';

const App = () => {

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <MyLayout />
    </Router>
  );
};

export default App;
